import Delta from 'quill-delta';
import { List } from 'immutable';
import getOperationOffset from '../utils/getOperationOffset';
import convertMarksToAttributes from '../utils/convertMarksToAttributes';
export default function addMark(op, editor) {
  var node = editor.value.document.getNode(op.path);
  var marks = convertMarksToAttributes({
    marks: new List([op.mark])
  });
  return new Delta().retain(getOperationOffset(op, editor)).retain(node.text.length, marks);
}